import React, { Component } from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

class SettingsTile extends Component<any, any> {
    
    render() {
        const {
            buttonMethod,
            buttonTitle,
            sectionTitle,
            descriptionSection,
            disabled,
        } = this.props;
        return (
            <View style={styles.ButtonContainer}>
                <Text style={styles.deviceSectionTitle}>{sectionTitle.toUpperCase()}</Text>
                <View style={styles.horizontalSeparator} />
                <View style={styles.descriptionSection}>
                    {descriptionSection}
                </View>
                {!disabled &&
                <Button
                    title={buttonTitle}
                    fontColor={Theme.WHITE}
                    buttonType={ButtonTypes.NORMAL}
                    containerStyle={styles.button}
                    onPress={buttonMethod}
                />}
            </View>
        )
    }
}


const styles = StyleSheet.create({
    ButtonContainer: {
        flexDirection: 'column',
        justifyContent: 'space-around',
        minHeight: defaultScale(60),
        borderRadius: defaultScale(5),
        backgroundColor: Theme.WHITE,
        padding: defaultScale(5),
        marginVertical: defaultScale(10),
        marginHorizontal: defaultScale(10),
    },
    button: {
        margin: defaultScale(10),
    },
    deviceSectionTitle: {
        ...Theme.textStyle.heading,
        color: Theme.BLACK,
        padding: defaultScale(10),
        alignSelf: 'center',
    },
    deviceSectionData: {
        ...Theme.textStyle.bodyCopyMed,
        color: Theme.CHARCOAL,
        padding: defaultScale(10),
        alignSelf: 'center',
    },
    horizontalSeparator: {
        borderBottomWidth: 1,
        borderBottomColor: Theme.GREY,
        marginHorizontal: defaultScale(10),
    },
    descriptionSection: {
        alignSelf: 'center',
        paddingVertical: defaultScale(10)
    }
});

export default SettingsTile;
